import { render, staticRenderFns } from "./duibifenxibiao.vue?vue&type=template&id=6e20c8cf&scoped=true&"
import script from "./duibifenxibiao.vue?vue&type=script&lang=js&"
export * from "./duibifenxibiao.vue?vue&type=script&lang=js&"
import style0 from "./duibifenxibiao.vue?vue&type=style&index=0&id=6e20c8cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e20c8cf",
  null
  
)

export default component.exports